import React from "react";
import moment from 'moment';
import DatePicker from "react-datepicker";
import Question from '../components/Question'
import { Form } from 'react-bootstrap'
import QuoteStep from "./QuoteStepLayout";
import QuoteStepBase, { mapInsuranceStepProps, getInsuranceStepMapDispatch } from '../components/QuoteStepBase'
import ButtonContinue from "../components/ButtonContinue";
import Calendar from "../components/Calendar";
import Utilities from "../classes/Utilities";
import { IQuoteStepState, ICurrentInsuranceStepProps } from "../components/interfaces";
import { ValidatableForm } from "../components/ValidatableForm";
import { connect } from "react-redux";
import { validationUtils } from "../validation/Validation";
import { PATHS, QUOTE_STEPS, COMPONENTS, QUOTE_QUESTIONS } from "../AppConstants";

const tomorrow = moment(new Date()).add(1, 'd').toDate();
const today = new Date();

interface IYourNewPolicyState extends IQuoteStepState {
    currentPolicyExpirationDate : Date,
    effectiveDate : string,
    otherEffectiveDate : Date,
    effectiveDateOption : string,
    otherEffectiveDateOptionLabel : string,
    otherEffectiveDateOptionVisible : boolean,
    otherEffectiveDateOptionSelected : boolean,
    receiveDocumentsElectronically : string,
    effectiveDateOptions : Array<string>,
}

interface IOtherEffDateProps {
    selected?: boolean,
    value?: string,
    label: string,
    onSelected?: () => void,
    onClick?: () => void;
}

class OtherEffDateInput extends React.Component<IOtherEffDateProps> {
    constructor(props: IOtherEffDateProps) {
        super(props);
        this.onSelected = this.onSelected.bind(this);
    }

    onSelected() {
        if (this.props.onSelected)
            this.props.onSelected();
        if (this.props.onClick)
            this.props.onClick();
    }

    render() {
        return (
            <div className="question m-t-0 m-b-0">
                <div className="radioInline">
                    <div>
                        <label className={"radioPad__wrapper" + (this.props.selected ? " radioPad__wrapper--selected" : "")} onClick={this.onSelected}>
                            {this.props.label}
                        </label>
                    </div>
                </div>
            </div>
        );
    };
}
    
class YourNewPolicy extends QuoteStepBase<ICurrentInsuranceStepProps, IYourNewPolicyState> {
    constructor(props: ICurrentInsuranceStepProps) {
        super(props);
        this.next = this.next.bind(this);
        this.onEffDateChange = this.onEffDateChange.bind(this);
                
        this.state = {
            currentPolicyExpirationDate: tomorrow,
            effectiveDate: this.props?.currentInsurance?.effectiveDate ?? today.toDateString(),
            otherEffectiveDate: new Date(),
            effectiveDateOption: QUOTE_QUESTIONS.NEW_POLICY.EFF_DATE_OPTIONS.TOMORROW,
            otherEffectiveDateOptionLabel: QUOTE_QUESTIONS.NEW_POLICY.EFF_DATE_OPTIONS.OTHER,
            otherEffectiveDateOptionVisible : false,
            otherEffectiveDateOptionSelected : false,
            receiveDocumentsElectronically: QUOTE_QUESTIONS.YES_NO.YES,
            effectiveDateOptions: [QUOTE_QUESTIONS.NEW_POLICY.EFF_DATE_OPTIONS.TODAY, QUOTE_QUESTIONS.NEW_POLICY.EFF_DATE_OPTIONS.TOMORROW],
            updatingStore: false,
            errors: null
        };
    }

    componentDidMount() {
        super.componentDidMount();
        this.props.reportCurrentStep();
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.meta.propsSource === COMPONENTS.PROPS_SOURCES.APP_STORE) {
            const currentInsurance = nextProps.currentInsurance;
            nextProps.meta.propsSource = "";
            //if (!currentInsurance || !currentInsurance.currentPolicyExpirationDate) return prevState;
            if (!currentInsurance) return prevState;

            return {
                ...prevState,
                currentPolicyExpirationDate: currentInsurance.currentPolicyExpirationDate,
                effectiveDate: currentInsurance.effectiveDate,
                otherEffectiveDate: currentInsurance.otherEffectiveDate,
                effectiveDateOption: currentInsurance.effectiveDateOption,
                otherEffectiveDateOptionVisible: currentInsurance.otherEffectiveDateOptionVisible,
                otherEffectiveDateOptionSelected: currentInsurance.otherEffectiveDateOptionSelected,
                receiveDocumentsElectronically: currentInsurance.receiveDocumentsElectronically,
                otherEffectiveDateOptionLabel: currentInsurance.otherEffectiveDateOptionSelected
                    ? Utilities.formatDateObj(currentInsurance.otherEffectiveDate)
                    : QUOTE_QUESTIONS.NEW_POLICY.EFF_DATE_OPTIONS.OTHER,
                effectiveDateOptions: moment(currentInsurance.currentPolicyExpirationDate).isSame(tomorrow, 'day')
                    ? [QUOTE_QUESTIONS.NEW_POLICY.EFF_DATE_OPTIONS.TODAY, QUOTE_QUESTIONS.NEW_POLICY.EFF_DATE_OPTIONS.TOMORROW]
                    : moment(currentInsurance.currentPolicyExpirationDate).isAfter(tomorrow, 'day')
                        ? [QUOTE_QUESTIONS.NEW_POLICY.EFF_DATE_OPTIONS.TOMORROW, YourNewPolicy.formatPolicyExpiresOption(currentInsurance.currentPolicyExpirationDate)]
                        : [QUOTE_QUESTIONS.NEW_POLICY.EFF_DATE_OPTIONS.TODAY, QUOTE_QUESTIONS.NEW_POLICY.EFF_DATE_OPTIONS.TOMORROW]
            };
        }

        return prevState;
    }

    next() {
        this.setState({ updatingStore: true }, () => {
            const updatedCurrentInsurance = {
                ...this.props.currentInsurance,
                currentPolicyExpirationDate: this.state.currentPolicyExpirationDate,
                effectiveDate: this.state.effectiveDate,
                receiveDocumentsElectronically: this.state.receiveDocumentsElectronically,
                otherEffectiveDate: this.state.otherEffectiveDate,
                effectiveDateOption: this.state.effectiveDateOption,
                otherEffectiveDateOptionVisible: this.state.otherEffectiveDateOptionVisible,
                otherEffectiveDateOptionSelected: this.state.otherEffectiveDateOptionSelected
            };

            this.props.updateAppState({ quoteUid: this.props.quoteUid, currentInsurance: updatedCurrentInsurance })
                .then(() => this.props.history.push(PATHS.CONTACT_INFO),
                    () => {
                        this.setState({ ...this.state, updatingStore: false });
                    });
        });
    }

    static formatPolicyExpiresOption(date: Date | null) {
        if (!date) return "";
        return QUOTE_QUESTIONS.NEW_POLICY.EFF_DATE_OPTIONS.WHEN_POLICY_EXPIRES + " (" + (date.getMonth() + 1) + "/" + date.getDate() + ")";
    }

    //onExpDateChange(date: Date | null) {
    //    if (moment(date).isAfter(tomorrow, 'day')) {
    //        this.setState({
    //            ...this.state,
    //            currentPolicyExpirationDate: date,
    //            otherEffectiveDateOptionVisible: true,
    //            otherEffectiveDateOptionSelected: false,
    //            otherEffectiveDateOptionLabel: QUOTE_QUESTIONS.NEW_POLICY.EFF_DATE_OPTIONS.OTHER,
    //            effectiveDateOptions: [
    //                QUOTE_QUESTIONS.NEW_POLICY.EFF_DATE_OPTIONS.TOMORROW,
    //                YourNewPolicy.formatPolicyExpiresOption(date)
    //            ]
    //        });
    //    }
    //    else {
    //        this.setState({
    //            ...this.state,
    //            currentPolicyExpirationDate: date,
    //            otherEffectiveDateOptionVisible: false,
    //            otherEffectiveDateOptionSelected: false,
    //            otherEffectiveDateOptionLabel: QUOTE_QUESTIONS.NEW_POLICY.EFF_DATE_OPTIONS.OTHER,
    //            effectiveDateOptions: [QUOTE_QUESTIONS.NEW_POLICY.EFF_DATE_OPTIONS.TODAY, QUOTE_QUESTIONS.NEW_POLICY.EFF_DATE_OPTIONS.TOMORROW]
    //        });
    //    }
    //}

    onEffDateChange(date: Date | null) {
        if (date) {
            this.setState({
                ...this.state,
                effectiveDate: date?.toDateString()
            });
        }
    }

    //onSelectEffectiveDateOption(value: string) {
    //    switch (value) {
    //        case QUOTE_QUESTIONS.NEW_POLICY.EFF_DATE_OPTIONS.TODAY:
    //            this.setState({
    //                ...this.state,
    //                effectiveDateOption: value,
    //                effectiveDate: new Date(),
    //                otherEffectiveDateOptionLabel: QUOTE_QUESTIONS.NEW_POLICY.EFF_DATE_OPTIONS.OTHER,
    //            });
    //            break;
    //        case QUOTE_QUESTIONS.NEW_POLICY.EFF_DATE_OPTIONS.TOMORROW:
    //            this.setState({
    //                ...this.state,
    //                effectiveDateOption: value,
    //                effectiveDate: tomorrow,
    //                otherEffectiveDateOptionLabel: QUOTE_QUESTIONS.NEW_POLICY.EFF_DATE_OPTIONS.OTHER
    //            });
    //            break;
    //        default:
    //            if (value === YourNewPolicy.formatPolicyExpiresOption(this.state.currentPolicyExpirationDate)) {
    //                this.setState({
    //                    ...this.state,
    //                    effectiveDateOption: value,
    //                    effectiveDate: this.state.currentPolicyExpirationDate,
    //                    otherEffectiveDateOptionLabel: QUOTE_QUESTIONS.NEW_POLICY.EFF_DATE_OPTIONS.OTHER
    //                });
    //            }
    //            break;
    //    }
    //}

    //onOtherEffectiveDateOptionSelected() {
    //    this.setState({ ...this.state, otherEffectiveDateOptionSelected: true, effectiveDateOption: "" });
    //}

    //onOtherEffectiveDateSelected(date: Date) {
    //    this.setState({
    //        ...this.state,
    //        effectiveDate: date,
    //        otherEffectiveDate: date
    //    });
    //}

    //onOtherEffectiveDateDatePickerClosed() {
    //    this.setState({
    //        ...this.state,
    //        otherEffectiveDateOptionLabel: Utilities.formatDateObj(this.state.otherEffectiveDate)
    //    });
    //}

    render() {
        return (
            <QuoteStep id={this.props.id}>
                <ValidatableForm hasErrors={null != this.state.errors}>
                    <div className="titleArea"><h5>YOUR NEW POLICY</h5></div>

                    {
                        //<Form.Group>
                        //    <Form.Label>When does your current policy expire?</Form.Label>
                        //    <Calendar
                        //        id="currentPolicyExpirationDate"
                        //        value={this.state.currentPolicyExpirationDate}
                        //        minDate={moment(new Date()).add(1, 'd').toDate()}
                        //        validated={null !== this.state.errors}
                        //        validationError={validationUtils.getValidationErrorFor(this.state.errors, "currentPolicyExpirationDate")}
                        //        onChange={this.onExpDateChange} />
                        //</Form.Group>
                    }

                    <Form.Group>
                        <Form.Label>Policy Effective Date</Form.Label>
                        <Calendar
                            id="effectiveDate"
                            value={new Date(this.state.effectiveDate)}
                            minDate={today}
                            maxDate={moment(new Date()).add(30, 'd').toDate()}
                            validated={null !== this.state.errors}
                            validationError={validationUtils.getValidationErrorFor(this.state.errors, "effectiveDate")}
                            onChange={this.onEffDateChange} />
                    </Form.Group>

                    {
                        //<div className="eff-date-options">
                        //    <Question
                        //        name="effectiveDateOption"
                        //        className={this.state.otherEffectiveDateOptionVisible ? "m-b-0" : ""}
                        //        selectedValue={this.state.effectiveDateOption}
                        //        error={validationUtils.getValidationErrorFor(this.state.errors, "effectiveDateOption")}
                        //        selected={(v) => this.onSelectEffectiveDateOption(v)}
                        //        items={this.state.effectiveDateOptions}
                        //        lable="When do you want your new policy to start?" />

                        //    {this.state.otherEffectiveDateOptionVisible
                        //        ? <DatePicker
                        //            selected={this.state.otherEffectiveDate}
                        //            onChange={date => this.onOtherEffectiveDateSelected(date)}
                        //            onCalendarClose={() => this.onOtherEffectiveDateDatePickerClosed()}
                        //            customInput={
                        //                <OtherEffDateInput label={this.state.otherEffectiveDateOptionLabel}
                        //                    selected={this.state.otherEffectiveDateOptionSelected}
                        //                    onSelected={() => this.onOtherEffectiveDateOptionSelected()} />}
                        //        />
                        //        : null}

                        //    {null !== this.state.errors && validationUtils.hasValidationErrorFor(this.state.errors, "effectiveDate")
                        //        ? <Form.Control.Feedback type="invalid">
                        //            {validationUtils.getValidationErrorFor(this.state.errors, "effectiveDate")}
                        //        </Form.Control.Feedback>
                        //        : null
                        //    }

                        //</div>
                    }

                    <div className="docs-electronically">
                        <Question
                            name="receiveDocumentsElectronically"
                            selectedValue={this.state.receiveDocumentsElectronically}
                            error={validationUtils.getValidationErrorFor(this.state.errors, "receiveDocumentsElectronically")}
                            selected={(v) => { }}
                            items={[QUOTE_QUESTIONS.YES_NO.YES, QUOTE_QUESTIONS.YES_NO.NO]}
                            lable="Are you willing to sign and receive insurance policy documents electronically?" />
                    </div>

                    <div className="btnContainer">
                        <ButtonContinue
                            disabled={this.state.updatingStore}
                            showLoading={this.state.updatingStore}
                            onClick={this.next} />
                    </div>

                </ValidatableForm>
            </QuoteStep>
        );
    }
}

export default connect(mapInsuranceStepProps, getInsuranceStepMapDispatch(QUOTE_STEPS.NEW_POLICY))(YourNewPolicy);
